module.exports = "<div class=\"alert alert-warning\" *ngIf=\"isVisible\">\n  <strong>Warning:</strong>\n  This setting differs between the groups in this wave. Changing it here will overwrite for all groups.\n  <a href=\"\" (click)=\"undo()\">UNDO</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/group/wave-differs-warning/wave-differs-warning.component.html
// module id = ../../../../../src/app/dashboard/program-list/program/groups/group/wave-differs-warning/wave-differs-warning.component.html
// module chunks = 2